export default __webpack_public_path__ + "static/media/bee-silo.b928c4d0.svg";